module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("页面未找到！")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62d0bca4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/404.vue
// module id = 560
// module chunks = 2